import React, { useState } from 'react'

import { Image } from '../Image'
import { FeedbackPopup } from '../../sections/Tabloids/TabloidShareLink/FeedbackPopup'
import { CopyIcon } from '../../../assets/CopyIcon'
import { HAS_WINDOW } from '../../../constants'

import type { Vouchers as VouchersProps } from '../../../types/ClubCard/ClubCardUser'

import './voucher.scss'

type VoucherProps = VouchersProps['voucher'] & { voucherValue: string }

export function Voucher({
  image,
  text,
  buttonText,
  voucherValue,
}: VoucherProps) {
  const [isPopupVisible, setIsPopupVisible] = useState(false)

  const handleClick = () => {
    if (!HAS_WINDOW) {
      return
    }

    setIsPopupVisible(true)
    setTimeout(() => setIsPopupVisible(false), 3000)

    navigator?.clipboard?.writeText(voucherValue)
  }

  return (
    <div className="voucher-container">
      <Image
        alt={image.alt}
        baseUrl={image.src}
        width={64}
        height={64}
        objectFit="contain"
      />

      <div>
        <p className="voucher-text">{text}</p>
        <p>{voucherValue}</p>
      </div>

      <button onClick={handleClick}>
        <CopyIcon />
        {buttonText}
      </button>

      {isPopupVisible && <FeedbackPopup text="Cupom copiado com sucesso!" />}
    </div>
  )
}
